<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <h4 class="card-title"><i class="mdi mdi-settings"></i> Settings</h4>
                </div>
            </div>
            <form class="form-horizontal">
                <div class="form-body">
                    <div class="card-body card-blue">
                        <div class="form-group row">
                            <label class="control-label text-right col-md-3">Timezone:</label>
                            <div class="col-md-9">
                                <p class="form-control-static"> {{savedSettings.timezone}} </p>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="control-label text-right col-md-3">Date Format:</label>
                            <div class="col-md-9">
                                <p class="form-control-static"> {{savedSettings.dateformat}} </p>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="control-label text-right col-md-3">Base Currency:</label>
                            <div class="col-md-9">
                                <p class="form-control-static"> {{savedSettings.currencyname}} {{savedSettings.currencysymbol}} </p>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="role === 'ORG_ADMIN'">
                        <div class="col-md-12 text-right">
                            <router-link :to="{ name: 'editsettings'}" class="btn btn-info">
                                <i class="fas fa-pencil-alt"></i> Edit Settings
                            </router-link>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";

    export default {
        name: "Settings",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie},
        data() {
            return {
                role: "",
                savedSettings: {
                    timezone: null,
                    timezoneoffset: null,
                    dateformat: null,
                    currencyid: null,
                    currencyname: null,
                    currencysymbol: null
                }
            };
        },
        mounted() {
            console.log(this.currentOrg);
            this.role = this.currentOrg.role;
            this.init();
        },
        methods: {
            async init() {
                await this.getSettings();
            },
            async getSettings() {
                $(".preloader").fadeIn();
                let reply          = await this.$http.get("/org/" + this.currentOrg.id + "/setting");
                $(".preloader").fadeOut();
                this.savedSettings = reply.data;
                this.settings      = {
                    currencyid: this.savedSettings.currencyid,
                    timezone: {
                        value: this.savedSettings.timezone,
                        offset: this.savedSettings.timezoneoffset
                    },
                    dateformat: this.savedSettings.dateformat
                };
            }
        }
    }
</script>

<style scoped>

</style>
